<div class="flex flex-row mr-4 items-center">
  <dx-toolbar [width]="237" class="field-editor-map-toolbar">
    <dxi-item location="before" widget="dxButton">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <!--<span class="block mr-2 text-sm font-medium">Mode: </span>-->
          <dx-button-group
            [items]="viewModes"
            keyExpr="mode"
            stylingMode="text"
            [selectedItemKeys]="[viewMode]"
            (onItemClick)="itemClick($event)">
          </dx-button-group>
        </div>
      </div>
    </dxi-item><!--
  <dxi-item location="before"
            widget="dxButton"
            locateInMenu="auto"
            [options]="refreshButtonOptions">
  </dxi-item>
  <dxi-item location="center"
            widget="dxButton"
            locateInMenu="never">
    <div *dxTemplate>
      <div class='toolbar-label'><b>Tom's Club</b> Products</div>
    </div>
  </dxi-item>
  &lt;!&ndash;  <dxi-item location="after"
              widget="dxSelectBox"
              locateInMenu="auto"
              [options]="selectBoxOptions">
    </dxi-item>&ndash;&gt;
  <dxi-item location="after"
            widget="dxButton"
            locateInMenu="auto"
            [options]="addButtonOptions">
  </dxi-item>
  <dxi-item widget="dxButton"
            locateInMenu="always"
            [options]="saveButtonOptions">
  </dxi-item>
  <dxi-item widget="dxButton"
            locateInMenu="always"
            [options]="printButtonOptions">
  </dxi-item>
  <dxi-item widget="dxButton"
            locateInMenu="always"
            [options]="settingsButtonOptions">
  </dxi-item>-->
  </dx-toolbar>


  <dx-toolbar [width]="237" class="field-editor-map-toolbar">
    <dxi-item location="before" widget="dxButton">
      <div *dxTemplate>
        <div class="flex flex-row mr-4 items-center">
          <span class="block mr-2 text-sm font-medium">Edition: </span>
          <dx-button-group
            [items]="editModes"
            keyExpr="mode"
            stylingMode="text"
            [selectedItemKeys]="[editMode]"
            (onItemClick)="itemClick($event)">
          </dx-button-group>
        </div>
      </div>
    </dxi-item>
  </dx-toolbar>
</div>
<!--
<dx-button-group
  class="multiple-selection-styling-mode"
  [items]="fontStyles"
  keyExpr="style"
  stylingMode="text"
  selectionMode="multiple"
  (onItemClick)="itemClick($event)">
</dx-button-group>
-->
